export class MarkdownElement {
  constructor(element) {
    this.element = element;
    this.processTemplates();
  }

  processTemplates() {
    const username = document.querySelector("#account .name")?.dataset.username;

    this.element.querySelectorAll(".markdown-html").forEach((markdownHtml) => {
      const html = markdownHtml.innerHTML.replace(
        /%7B%7B(.+?)%7D%7D/g,
        "{{$1}}",
      );
      markdownHtml.innerHTML = this.renderTemplate(html, { username });
    });
  }

  renderTemplate(template, data) {
    return template.replace(/\{\{([^}]+)\}\}/g, (match, key) => {
      const trimmedKey = key.trim();
      return data[trimmedKey] !== undefined ? data[trimmedKey] : "";
    });
  }
}

export function initializeMarkdownElements(selector) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => new MarkdownElement(element));
}
